import { SAVED_FILTER_VIEWS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/saved_filter_views_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'workOrdersSavedViewsIndex',
	'invoicesSavedViewsIndex',
	'quotesSavedViewsIndex',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
